import CartAPI from 'cart/api/cart';

const state = {
  cartByConversationId: {},
  loading: {},
  error: {},
};

const getters = {
  getCartByConversation: $state => conversationId =>
    $state.cartByConversationId[conversationId] || null,
  isLoading: $state => conversationId => !!$state.loading[conversationId],
};

const mutations = {
  SET_CART(state, { conversationId, cart }) {
    state.cartByConversationId = {
      ...state.cartByConversationId,
      [conversationId]: cart,
    };
  },
  SET_LOADING(state, { conversationId, value }) {
    state.loading = { ...state.loading, [conversationId]: value };
  },
  SET_ERROR(state, { conversationId, error }) {
    state.error = { ...state.error, [conversationId]: error };
  },
};

const actions = {
  async fetchByContact({ commit }, { conversationId, contactId }) {
    if (!contactId) return;
    commit('SET_LOADING', { conversationId, value: true });
    try {
      const { data } = await CartAPI.openCart(contactId);
      commit('SET_CART', { conversationId, cart: data.cart });
    } catch (e) {
      commit('SET_ERROR', { conversationId, error: e.message });
    } finally {
      commit('SET_LOADING', { conversationId, value: false });
    }
  },

  async addItem({ commit }, { conversationId, cartId, variantId, quantity }) {
    try {
      const { data } = await CartAPI.addItem(cartId, { variantId, quantity });
      commit('SET_CART', { conversationId, cart: data.cart });
    } catch (e) {
      commit('SET_ERROR', { conversationId, error: e.message });
      throw e;
    }
  },

  async updateItem({ commit }, { conversationId, cartId, itemId, quantity }) {
    try {
      const { data } = await CartAPI.updateItem(cartId, itemId, { quantity });
      commit('SET_CART', { conversationId, cart: data.cart });
    } catch (e) {
      commit('SET_ERROR', { conversationId, error: e.message });
      throw e;
    }
  },

  async removeItem({ commit }, { conversationId, cartId, itemId }) {
    try {
      const { data } = await CartAPI.removeItem(cartId, itemId);
      commit('SET_CART', { conversationId, cart: data.cart });
    } catch (e) {
      commit('SET_ERROR', { conversationId, error: e.message });
      throw e;
    }
  },

  async applyDiscount({ commit }, { conversationId, cartId, code }) {
    const { data } = await CartAPI.applyDiscount(cartId, code, conversationId);
    commit('SET_CART', { conversationId, cart: data.cart });
  },

  async removeDiscount({ commit }, { conversationId, cartId }) {
    const { data } = await CartAPI.removeDiscount(cartId, conversationId);
    commit('SET_CART', { conversationId, cart: data.cart });
  },

  async sendCheckoutLink({ commit }, { conversationId, cartId, messageText }) {
    const { data } = await CartAPI.sendCheckoutLink(cartId, {
      messageText,
      conversationId,
    });
    commit('SET_CART', { conversationId, cart: data.cart });
  },

  async newCart({ commit }, { conversationId, contactId }) {
    commit('SET_LOADING', { conversationId, value: true });
    try {
      const { data } = await CartAPI.newCart(contactId);
      commit('SET_CART', { conversationId, cart: data.cart });
    } catch (e) {
      commit('SET_ERROR', { conversationId, error: e.message });
      throw e;
    } finally {
      commit('SET_LOADING', { conversationId, value: false });
    }
  },

  async shippingQuote(_, { cartId, recipientCep }) {
    const { data } = await CartAPI.shippingQuote(cartId, recipientCep);
    return data.options;
  },

  async applyShipping({ commit }, { conversationId, cartId, serviceCode, name, price, deliveryTime }) {
    const { data } = await CartAPI.applyShipping(cartId, { serviceCode, name, price, deliveryTime });
    commit('SET_CART', { conversationId, cart: data.cart });
  },

  setCart({ commit }, { conversationId, cart }) {
    commit('SET_CART', { conversationId, cart });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
